import { Component } from '@angular/core';

@Component({
  selector: 'qiasphere-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {}
